module.exports = __webpack_public_path__ + "static/img/logo19.64799d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo19.jpg
// module id = ihlr
// module chunks = 1